const themeColors = {
  primary: '#003366',
  secondary: '#101828',
  success: '#008055',
  danger: '#CC334D',
  grey: '#D9DADB',
  dark: '#2F475E',
  warning: '#ffa407ff',
  AI: '#ba55d3',
};

export default themeColors;
